import React, { useContext, useEffect } from 'react';
import { Indent } from '@bankiru/ui-kit/components/Indent';
import PageContext from '../../context/context';

export const Adfox = () => {
	const { isMobile } = useContext(PageContext);

	const banerId = isMobile ? 'adfox_174548425665583023' : 'adfox_174551009356523023';

	useEffect(() => {
		const initBanner = () => {
			window.yaContextCb.push(() => {
				Ya.adfoxCode.create({
					ownerId: 402339,
					containerId: banerId,
					params: {
						p1: isMobile ? 'dhjyt' : 'dhjys',
						p2: isMobile ? 'hoep' : 'hntg',
					},
				});
			});
		};

		initBanner();
	}, []);

	return (
		<Indent margin={isMobile ? '32 0 0 0' : '80 0 0 0'}>
			<div id={banerId}></div>
		</Indent>
	);
};
